import firebase from 'firebase/app'
import 'firebase/storage'
const db = firebase.firestore()

const state = {
  hike: null,
  hikes: [],
  myHikes: [],
  isHikesLoading: false,
  isMyHikesLoading: false,
  userHikes: [],
  usersStats: []
}

const actions = {
  GET_HIKES ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_HIKES_LOADING', true)
      let ref = db.collection('hikes')
      let unsub = ref.onSnapshot(snapshot => {
        let hikes = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          hikes.push(log)
        })
        commit('SET_LOADED_HIKES', hikes)
        commit('SET_HIKES_LOADING', false)
        resolve(unsub)
      }, (error) => {
        reject(error)
      })
    })
  },
  GET_MY_HIKES ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_MY_HIKES_LOADING', true)
      let ref = db.collection('hikes').where('submittedBy', '==', payload)
      let unsub = ref.onSnapshot(snapshot => {
        let hikes = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          hikes.push(log)
        })
        commit('SET_LOADED_MY_HIKES', hikes)
        commit('SET_MY_HIKES_LOADING', false)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  GET_HIKE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADED_HIKE', null)
      db.collection('hikes').doc(payload).get()
        .then((doc) => {
          if (doc.exists) {
            const hikeData = doc.data()
            // Add the id field to the hikeData object
            hikeData.id = doc.id
            resolve(hikeData)
            commit('SET_LOADED_HIKE', hikeData)
          } else {
            reject(new Error('No such document!'))
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  CREATE_HIKE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('hikes').add(payload)
        .then((docRef) => {
          resolve(docRef)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  DELETE_HIKE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('hikes').doc(payload).delete()
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  UPDATE_HIKE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('hikes').doc(payload.id).update(payload.data)
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  UPLOAD_GPS_TRACK ({ commit, state }, { file, userId }) {
    return new Promise(async (resolve, reject) => {
      try {
        const storageRef = firebase.storage().ref()
        const fileRef = storageRef.child(`users/${userId}/gpsTracks/${file.name}`)
        await fileRef.put(file)
        const fileURL = await fileRef.getDownloadURL()
        resolve(fileURL)
      } catch (error) {
        reject(error)
      }
    })
  },
  async DELETE_GPS_TRACK ({ commit, state }, { gpsTrackName, userId }) {
    try {
      const storageRef = firebase.storage().ref()
      const fileRef = storageRef.child(`users/${userId}/gpsTracks/${gpsTrackName}`)

      await fileRef.delete()
    } catch (error) {
      console.error('Error deleting the GPS track:', error)
      throw error
    }
  },
  GET_USER_HIKES ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('hikes').where('submittedBy', '==', payload).get()
        .then((snapshot) => {
          let hikes = []
          snapshot.forEach((doc) => {
            let log = {
              'id': doc.id,
              ...doc.data()
            }
            hikes.push(log)
          })
          commit('SET_LOADED_USER_HIKES', hikes)
          resolve(hikes)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  UPLOAD_PHOTO ({ commit, state }, { file, userId }) {
    return new Promise(async (resolve, reject) => {
      try {
        const storageRef = firebase.storage().ref()
        const fileRef = storageRef.child(`users/${userId}/photos/${file.name}`)
        await fileRef.put(file)
        const fileURL = await fileRef.getDownloadURL()
        resolve(fileURL)
      } catch (error) {
        reject(error)
      }
    })
  },
  GET_HIKE_STATS ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_HIKES_LOADING', true)
      let usersStats = []
      let ref = db.collection('hikes')
      let unsub = ref.onSnapshot(snapshot => {
        let hikes = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          hikes.push(log)
          // Update usersStats based on created hikes
          let existingUserStats = usersStats.find(userStats => userStats.userId === log.submittedBy)
          if (existingUserStats) {
            existingUserStats.totalDistance += Number(log.distance)
            existingUserStats.totalElevation += Number(log.elevation)
            existingUserStats.totalDuration += Number(log.durationHours)
          } else {
            usersStats.push({
              userId: log.submittedBy,
              totalDistance: Number(log.distance),
              totalElevation: Number(log.elevation),
              totalDuration: Number(log.durationHours),
              userName: '', // Initialize with empty values
              photoUrl: '' // Initialize with empty values
            })
          }
        })
        commit('SET_LOADED_HIKES', hikes)
        // Fetch user details for each userStats
        Promise.all(
          usersStats.map(async (userStats) => {
            const userDoc = await db.collection('users').doc(userStats.userId).get()
            const userData = userDoc.data()
            userStats.userName = userData.name ? userData.name : `${userData.firstName} ${userData.lastName}`
            userStats.photoUrl = userData.photoUrl ? userData.photoUrl : '' // Set the photoUrl if available
            return userStats
          })
        )
          .then((updatedUserStats) => {
            commit('SET_USERS_STATS', updatedUserStats) // Store the updated userStats with user details
            commit('SET_HIKES_LOADING', false)
            resolve(unsub)
          })
          .catch((error) => {
            reject(error)
          })
      }, (error) => {
        reject(error)
      })
    })
  }
}

const getters = {
}

const mutations = {
  SET_LOADED_HIKES (state, payload) {
    state.hikes = payload
  },
  SET_LOADED_MY_HIKES (state, payload) {
    state.myHikes = payload
  },
  SET_LOADED_HIKE (state, payload) {
    state.hike = payload
  },
  SET_HIKES_LOADING (state, isLoading) {
    state.isHikesLoading = isLoading
  },
  SET_MY_HIKES_LOADING (state, isLoading) {
    state.isMyHikesLoading = isLoading
  },
  SET_LOADED_USER_HIKES (state, payload) {
    state.userHikes = payload
  },
  SET_USERS_STATS (state, payload) {
    state.usersStats = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
